const routes = [
    {
        path: "/pilotage/payments",
        component: () => import("../pages/Index"),
        meta: {
            isAuthenticated: true,
            permission: "pilotagepayment_index"
        }
    },

];

export default routes;
